import { render } from "./SimplePerfLive.vue?vue&type=template&id=2f8103ee&scoped=true&ts=true"
import script from "./SimplePerfLive.vue?vue&type=script&lang=ts"
export * from "./SimplePerfLive.vue?vue&type=script&lang=ts"

import "./SimplePerfLive.vue?vue&type=style&index=0&id=2f8103ee&scoped=true&lang=css"
import "./SimplePerfLive.vue?vue&type=style&index=1&id=2f8103ee&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8103ee"]])

export default __exports__